import { Component, inject, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  listRow,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { LogService } from 'BaseServices/log-service';
import { MainService } from 'BaseServices/main-service';
import {
  ClientDetailDTO,
  ClientSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import { ClientDialogComponent } from 'projects/Assets/src/assets-base/Dialogs/client-dialog/client-dialog.component';
import {
  BaseListPageComponent,
  multiSelectFilterList,
} from 'src/app/BasePages/base-list-page/base-list-page.component';

@Component({
  selector: 'app-client-view',
  imports: [BaseListPageComponent],
  templateUrl: './client-view.component.html',
  styleUrl: './client-view.component.css',
})
export class ClientViewComponent {
  extraBurgerMenuOptions: MenuOption[] = [];
  headerList: string[] = ['Navn'];
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<ClientSummaryDTO>;
  readonly dialog = inject(MatDialog);
  logHeaderList: string[];

  multiSelectFilterLists: multiSelectFilterList[] = [];
  clients: ClientSummaryDTO[] = [];
  constructor(
    private mainService: MainService,
    private logService: LogService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('aftale'); // Lige nu ser den ud til at være lavet til specifikt timelog så vi skal tage en beslutning med det her
  }

  ngAfterViewInit(): void {
    this.updateListAgreements();
  }
  updateMultiSelectFilterLists() {
    var list = [];

    var clientList: multiSelectFilterList = {
      Items: this.clients,
      selectedItemsIds: this.clients.map((c) => c.id),
      placeHolderText: 'Vælg Kunde',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (client: ClientSummaryDTO) {
        return client != null && this.selectedItemsIds.includes(client.id);
      },
    };
    list.push(clientList);
    this.multiSelectFilterLists = list;
  }
  agreementClicked = (client?: ClientSummaryDTO) => {
    const clientRequest: ClientDetailDTO = {
      id: client?.id ?? 0,
      name: client?.name ?? '',
      plants: [],
      agreements: [],
      jobs: [],
      components: [],
      features: [],
    };

    const dialogRef = this.dialog.open(ClientDialogComponent, {
      data: { data: [clientRequest] },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.updateListAgreements();
      }
    });
  };

  switchDataInList() {
    // TODO få til at ligne den i courseParticipant componetn
  }

  updateListAgreements() {
    this.mainService
      .getAll<ClientSummaryDTO>('client')
      .subscribe((clients) => {
        this.clients = clients;
        this.updateMultiSelectFilterLists();

        let listData: listRow<ClientSummaryDTO>[] = [];
        clients.forEach((client) => {
          listData.push({
            object: client,
            id: client.id,
            data: [client.name],
          });
        });
        this.baseListPage.UpdateListData(listData);
      });
  }
}
